import { useEffect } from "react";
import { SITE_NAME } from "../config/site";

/* Sets <title> per route. Without this every page shares the index.html title,
   which hurts search results, browser history and shared links. */
export default function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title
      ? `${title} | ${SITE_NAME}`
      : `${SITE_NAME} | Wholesale Distribution`;
  }, [title]);
}
